export const SEARCH_LIMIT = {
	assets: 20,
	files: 20,
	tableColumns: 50,
}
